export default __webpack_public_path__ + "static/media/BnR-Hero-Logo-Color-Dark.47f2f5fe.jpg";